import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useOrder = (id) => useQuery({ queryKey: [`order`, id], queryFn: async () => {
    if(!id) return null
    const callback = await API.get(`/orders/${id}`)
    return callback?.data
}, staleTime: 1000 * 60 * 5 })

export default useOrder